import { button, type ButtonVariants } from './buttonStyles'

export type ButtonProps = Omit<ButtonVariants, 'disabled'> &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
    className?: string
  }

/**
 * The standard button. Styling lives in ./buttonStyles so elements that must look
 * like a button without being one (see OmnidekPortalLink) share the same recipe.
 */
export function Button({
  intent,
  size,
  fullWidth,
  className,
  type = 'button',
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={button({ intent, size, fullWidth, disabled, className })}
      {...rest}
    />
  )
}
